var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var trackEvent = function (event_name, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.category, category = _c === void 0 ? "" : _c, _d = _b.subcategory, subcategory = _d === void 0 ? "" : _d, specificProps = _b.specificProps;
    var utagObj = __assign({ event_name: event_name, page_path: location.pathname, tomtom_domain: location.origin, page_category: category, page_subcategory: subcategory }, specificProps);
    if ("utag" in window) {
        utag.link(utagObj);
    }
};
//# sourceMappingURL=Tracking.js.map